import { z } from 'zod';
import excludedEmailDomains from '../constants/excludedEmailDomains';

const EMAIL_MAX_LENGTH = 80;

export const heroEmailFormSchema = z.object({
  email: z
    .string()
    .min(1, 'form.Required field')
    .email('form.Invalid email format')
    .max(EMAIL_MAX_LENGTH)
    .transform((value) => value.toLowerCase())
    .refine(
      (value) => !excludedEmailDomains.some((domain) => value.includes(domain)),
      'form.Company email domains only'
    ),
});
